import { EmojiProvider, Emoji } from "react-apple-emojis"
import emojiData from "react-apple-emojis/src/data.json"
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { BP } from "../../../util/constants/breakpoints";

export default function Hero() {

    const [headerEmojiWidth, setHeaderEmojiWidth] = useState(36);

    const smallest = 24;
    const mobileHeaderEmojiWidth = 36;
    const desktopHeaderEmojiWidth = 52;

    const onWindowWidthChange = () => {
        setHeaderEmojiWidth(getHeaderEmojiWidth())
    }

    const getHeaderEmojiWidth = () => {

        if(window.innerWidth < BP.xs) return smallest;

        if(window.innerWidth < BP.sm) return mobileHeaderEmojiWidth 
        else return desktopHeaderEmojiWidth 
    }

    useEffect(() => {
        setHeaderEmojiWidth(getHeaderEmojiWidth)
        window.addEventListener("resize", onWindowWidthChange)
        return () => window.removeEventListener("resize", onWindowWidthChange)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return(
        <>
            <div 
                className="
                    bg-home-bg-light 
                    dark:bg-home-bg-dark
                    w-screen 
                    h-screen
                    flex
                    flex-col
                    justify-center
                    items-center
                    gap-y-2.5
                    sm:gap-y-7
                "
            >
                <h1
                    className="
                        text-xs
                        text-home-text-grey
                        tracking-wide
                        sm:text-base
                    "
                >
                    Independent Software Developer
                </h1>
                <h2
                    className="
                        text-2xl
                        xs:text-3xl
                        sm:text-5xl
                        text-home-text-light
                        dark:text-home-text-dark
                        tracking-widest
                        font-bold

                        flex
                        items-center
                    "
                >
                    Hi, I'm Wei Jian&nbsp;
                    <EmojiProvider data={emojiData}>
                        <Emoji className="inline" name="banana" width={headerEmojiWidth}/>
                    </EmojiProvider>
                </h2>
                <h3
                    className="
                        text-xs
                        sm:text-xl
                        text-home-text-grey
                        tracking-wide
                    "
                >
                    Have an idea in mind?&nbsp;
                    <Link 
                        className="
                            underline 
                            underline-offset-2 
                            sm:underline-offset-4 
                            hover:text-home-text-primary 
                            transition-colors 
                            duration-300" 
                        to="/Contact"
                    >Let's Build &rarr;</Link>
                </h3>
            </div>
        </>
    );
}